(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('NumReferenceContrat', NumReferenceContrat);

    NumReferenceContrat.$inject = ['$resource'];

    function NumReferenceContrat ($resource) {
        var resourceUrl =  'api/num-reference-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
